/**
 * Кнопка «наверх» для лендингов (аналог ScrollToTop.vue / PrimeVue ScrollTop).
 */
const THRESHOLD_PX = 400;

function createButton() {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'scroll_to_top';
    button.setAttribute('aria-label', 'Наверх');
    button.hidden = true;
    button.innerHTML = '<i class="pi pi-chevron-up scroll_to_top__icon" aria-hidden="true"></i>';
    return button;
}

function updateVisibility(button) {
    const shouldShow = window.scrollY > THRESHOLD_PX;
    button.hidden = !shouldShow;
}

function initScrollToTop() {
    if (document.querySelector('.scroll_to_top')) {
        return;
    }

    const button = createButton();
    document.body.appendChild(button);

    button.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener(
        'scroll',
        function () {
            updateVisibility(button);
        },
        { passive: true }
    );

    updateVisibility(button);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollToTop);
} else {
    initScrollToTop();
}
